import { render, staticRenderFns } from "./SavedSearchAdministration.vue?vue&type=template&id=2b341f96&scoped=true"
import script from "./SavedSearchAdministration.vue?vue&type=script&lang=js"
export * from "./SavedSearchAdministration.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchAdministration.vue?vue&type=style&index=0&id=2b341f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b341f96",
  null
  
)

export default component.exports